import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Page4.css";
import { db } from "../firebase"; // ✅ Import your Firestore instance
import { collection, addDoc, serverTimestamp } from "firebase/firestore"; // ✅ Firestore helpers

// Page4 assets
import Garlands from "../assets/page4/Garlands@.png";
import RankIcon from "../assets/page4/icon_rank_gold@.png";
import RocketDivider from "../assets/page4/rocket-icon-divider@.png";
import TextBox from "../assets/page4/Word_Bubble_Parts@.png";
import Robot from "../assets/page4/Page4_iRobot@.png";
import SubmitButton from "../assets/page4/Submit_BTN@.png";
import Edlogo from "../assets/page4/Page4_Company-Logo@.png";
import GameLogo from "../assets/page4/game-icon-COPY@.png";
import AppStore from "../assets/page4/iOS-download-button-COPY@.png";
import PlayStore from "../assets/page4/Android-Download-Button-COPY@.png";
import ESRBrating from "../assets/page4/ESRB-rating@.png";
import LeftArt from "../assets/page4/left-corner-art.png";
import RightArt from "../assets/page4/right-corner-art.png";

const Page4 = () => {
  const [formData, setFormData] = useState({ name: "", email: "" });
  const [message, setMessage] = useState("");

  // ✅ Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // ✅ Submit to Firestore instead of axios
  const handleSubmit = async (event) => {
    event.preventDefault();
    setMessage("Submitting...");

    const { name, email } = formData;

    // ✅ Validation
    if (!name || !email) {
      setMessage("Please fill in both fields.");
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setMessage("Please enter a valid email address.");
      return;
    }

    try {
      // ✅ Add to Firestore collection
      await addDoc(collection(db, "signups"), {
        name,
        email,
        createdAt: serverTimestamp(),
        source: "RobotRace", // helpful for analytics later
      });

      setMessage("✅ Thank you for subscribing!");
      setFormData({ name: "", email: "" });
    } catch (error) {
      console.error("❌ Error writing document:", error);
      setMessage("Oops, something went wrong. Please try again later.");
    }
  };

  useEffect(() => {
    console.log("Updated message:", message);
  }, [message]);

  return (
    <div className="container-fluid g-0 page4">
      {/* Top Section */}
      <div className="topSection d-flex flex-column align-items-center justify-content-space">
        <div className="row-top">
          <img src={Garlands} className="garland1 img-fluid" alt="Left Garland" />
          <p className="testimony1">
            A rocket-fueled
            <br />
            rampage!
            <br />
            <span className="author">-WIRED</span>
          </p>

          <img src={RankIcon} className="rank-icon img-fluid" alt="Rank Icon" />

          <img src={Garlands} className="garland2 img-fluid" alt="Right Garland" />
          <p className="testimony2">
            Humorous
            <br />
            and fun!
            <br />
            <span className="author">-Indie Games Magazine</span>
          </p>
        </div>
        <img src={RocketDivider} className="rocket-divider img-fluid" alt="Rocket Divider" />
      </div>

      {/* Mid Section */}
      <div className="midSection justify-content-center align-items-center">
        <img src={TextBox} alt="Text Box" className="text-box img-fluid" />
        <h2 className="stay-connected">STAY CONNECTED!</h2>
        <p className="p4-content">
          Sign up for our mailing list to hear about the upcoming Multiplayer
          <br />
          release this April and receive special passwords for secret tracks!
        </p>

        <div className="name-container">
          <label htmlFor="name" className="name-label">NAME</label>
          <input
            type="text"
            id="name"
            name="name"
            className="name-input"
            value={formData.name}
            onChange={handleInputChange}
          />
        </div>

        <div className="email-container">
          <label htmlFor="email" className="email-label">E-MAIL</label>
          <input
            type="text"
            id="email"
            name="email"
            className="email-input"
            value={formData.email}
            onChange={handleInputChange}
          />
          <div className="message-container">
            <span className="email-message">{message}</span>
          </div>
        </div>

        <div className="image-button" onClick={handleSubmit}>
          <img src={SubmitButton} alt="Submit Button" className="submit-button" />
          <span className="button-text">SUBMIT</span>
        </div>

        <img src={Robot} alt="Robot" className="robot" />
        <img src={LeftArt} alt="Left Corner art" className="left-corner-art" />
        <img src={RightArt} alt="Right Corner art" className="right-corner-art" />
      </div>

      {/* Footer */}
      <div className="footer">
        <a href="http://easleydunnproductions.com/temp_index.html" target="_blank" rel="noopener noreferrer">
          <img src={Edlogo} alt="Easley-Dunn logo" className="edlogo" />
        </a>
        <img src={GameLogo} alt="Game Logo" className="game-logo" />
        <a href="https://apps.apple.com/ge/app/robot-race/id539184198#?platform=iphone" target="_blank" rel="noopener noreferrer">
          <img src={AppStore} alt="App Store" className="app-store" />
        </a>
        <a href="https://play.google.com/store/apps/details?id=com.easleydunnproductions.robotrace&hl=en_US&gl=US" target="_blank" rel="noopener noreferrer">
          <img src={PlayStore} alt="Play Store" className="play-store" />
        </a>
        <img src={ESRBrating} alt="ESRB rating" className="esrb-rating" />
        <p className="footer-content">
          All Rights Reserved 2025 | Easley-Dunn Games |
          <a href="http://easleydunnproductions.com/ContactUs.html" target="_blank" className="contact-link"> Contact Us</a> |
          <a href="https://easleydunnproductions.com/PrivacyPolicy.php" target="_blank" className="privacy-link"> Privacy Policy </a>
          | Website by Phred | Website Design by SpiderHandz
        </p>
      </div>
    </div>
  );
};

export default Page4;
